import React, { useCallback, useEffect, useRef, useState } from 'react'
import CopyToClip from '../../infra/CopyToClip';
import Cell from '../widgets/Cell';
import GuestForm from './GuestForm';
import NewPasswd from './NewPasswd';
import { isValidUsername,isValidAccountName, isValidEmail,isValidPersonName } from '../../hooks/useValidation';
import useMyFormState from '../../hooks/useMyFormState';
import { signUpUrl } from '../../providers/EnvContextProvider';
import useReserveEntity from '../../hooks/useReserveEntity';
import FormButton from '../widgets/FormButton';
import './SignUpOption.css'

export default function SignUpForm({accountPlan, title, price, bCall, desc, details, curActivePlan, activeSetter, tabPos}) {  
  const {handleAddError, handleRemoveError, submitEnabled, setSubmitEnabled} = useMyFormState();
  const [myActiveMode, setMyActiveMode] = useState('ready') // ready / active / muted
  const [showError, setShowError] = useState(false);
  const {reserveEntity} = useReserveEntity();
  const containerRef = useRef();
  const signUpRequestRef = useRef({}); // Also the Form Model

  const handlePlanClicked = useCallback(() => {
    activeSetter(accountPlan);
  }, [activeSetter, accountPlan]);


  // Effect - Pick a Card or Click outside or press [Esc]
  //
  useEffect(()=>{
    const handlePromiseError = (event) => {
      console.error('Unhandled promise rejection:', event.reason);
    }    

    const handleOutsideClick = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {                    
          // imOut(accountPlan);
        }
        else {
          activeSetter(accountPlan);
        }            
    }

    const handleKeyboard = (event) => {
      if (event.key === 'Escape') {
        activeSetter('');
      }
    }
  
    window.addEventListener('unhandledrejection', handlePromiseError);
    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('keydown', handleKeyboard);

    return () => {
      window.removeEventListener('unhandledrejection', handlePromiseError);
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('keydown', handleKeyboard);
    };
  }, [accountPlan, activeSetter]);
    

  // Effect - Focus plan or not
  //
  useEffect(()=>{
    if (accountPlan === curActivePlan) {
      setMyActiveMode('active');
    }
    else if (curActivePlan === '') {
      setMyActiveMode('ready');
    }
    else {
      setMyActiveMode('muted');
    }
  }, [curActivePlan, accountPlan]);

  const [passwd, setPasswd] = useState('');
  const [errorResp, setErrorResp] = useState({});
  
  // TODO: Integrate into useMyFormState as internal model that can be accessed (returned from the hook).
  //       - It will have to start as an empty object, and buildup on every setter..
  // const {get:getSignUpModel, set:refSetSignUpModel} = useSmartRef({
  //   acctName: '',
  //   username:'',
  //   email:'',
  //   firstName: ''
  // });
  // bibi-rak-bibi: GrtjLGF6F9bA9gN@JSpROn
  
  

  // TODO: Integrate into useMyFormState - same as above..
  const updateSignUpModel = useCallback( async (path, valueToUpdate) => {
    signUpRequestRef.current[path] = valueToUpdate;
    return true;
  }, []);

  // ---[  SAVE  ]---
  const handleReserveField = async (path, valueToReserve) => {
    updateSignUpModel(path, valueToReserve);
    return await reserveEntity(path, valueToReserve);
  }


  const generateUsername = useCallback(() => {
    const randomName = Math.random().toString(36).substring(2);
    updateSignUpModel('username', (accountPlan.startsWith('guest')) ? 'Guest-'+randomName : randomName);
  },[accountPlan, updateSignUpModel]);

  // -----[  USE EFFECT  ]----------
  // TODO: Reconsider "guest" user idea... especially for promoting after launch b"h.
  // useEffect(() => {
  //   let isMounted = true;
  //   if (isMounted && accountPlan.startsWith('guest')) {
  //     generateUsername();
  //   }
  
  //   return () => {
  //     isMounted = false;
  //   }
  // }, [accountPlan, generateUsername]);  
  
  // --------------------------------

  const handleSignUp = useCallback(async (e) => {
    setSubmitEnabled(false);
    console.log('[SignUpOption handleSignUp]');
    
    const signUpModel = signUpRequestRef.current;

    const response = await fetch(signUpUrl, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'accountName': signUpModel.accountName,
        'accountPlan': accountPlan,
        'username': signUpModel.username,
        'userEmail': signUpModel.userEmail,
        'userPhone': '',
        'firstName': (accountPlan.startsWith('guest')) ? 'Guest' : signUpModel.firstName,
        'midName':'',
        'lastName':''
      })
    }).catch(error => {
      console.error('Error SignUp: ' + error);
    });

    if (response.ok) {
      // Google Ads: Conversion Event on Successful SignUp
      window.gtag('event', 'conversion', {
          'send_to': 'AW-17189270506/Fjv5CIeWzdgaEOrnvYRA',
          'value': 1.0,
          'currency': 'ILS',
          'transaction_id': ''
      });

      const signUpResponse = await response.json();
      setPasswd(signUpResponse.passwd);      
      setErrorResp({});
    }
    else {
      console.error('SignUp Error: '+response.status+' - '+response.statusText);
      let errorData;
      if (response.status !== 502) {
        errorData = await response.json();                
      }
      else {
        errorData = {
          message: 'No Connection - (502 Bad Gateway)',
          cause: 'No internet or WiFi or kiponos.io server is down',
          suggestion: 'Check WiFi or Internet access or the status of the server at kiponos.io',
          logFinder: '502-Network-Down'
        }
      }

      console.error(JSON.stringify(errorData));
      setErrorResp(errorData);
    }    
  }, [accountPlan, setSubmitEnabled]);
  
  const isMuted = myActiveMode === 'muted';
  const signUpModel = signUpRequestRef.current;

  const formComp = accountPlan.startsWith('guest') ? <GuestForm generateUsername={generateUsername} username={signUpModel.username}/> : <div className='acctUsernameForm'>
        <Cell addError={handleAddError} removeError={handleRemoveError} path='accountName'  saveMe={handleReserveField} isRequired={true} validateMe={isValidAccountName} placeholder='Account name' isLocked={isMuted} tabIx={`${tabPos}1`}>{signUpModel.accountName}</Cell>
        <Cell addError={handleAddError} removeError={handleRemoveError} path='username'     saveMe={handleReserveField} isRequired={true} validateMe={isValidUsername}    placeholder='username (min 10 chars)' isLocked={isMuted} tabIx={`${tabPos}2`}>{signUpModel.username}</Cell>
        <Cell addError={handleAddError} removeError={handleRemoveError} path='userEmail'    saveMe={handleReserveField} isRequired={true} validateMe={isValidEmail}       placeholder='email'        isLocked={isMuted} tabIx={`${tabPos}3`}>{signUpModel.userEmail}</Cell>
        <Cell addError={handleAddError} removeError={handleRemoveError} path='firstName'    saveMe={updateSignUpModel}  isRequired={true} validateMe={isValidPersonName}  placeholder='First Name'   isLocked={isMuted} tabIx={`${tabPos}4`}>{signUpModel.firstName}</Cell>
      </div>

  const passwdComp = passwd ? <NewPasswd passwd={passwd}/> : '';

  const detailsComp = details.map((item, index) => (<li key={index}>{item}</li>));

  const activeStyle = `signUpOption ${myActiveMode}`;
  const wrapStyle = `signUpOptionWrapper`

  useEffect(()=>{
    setShowError(Boolean(errorResp?.title));
  },[errorResp]);

  return (
    <div className={wrapStyle}>
      <div className={activeStyle} onClick={handlePlanClicked} ref={containerRef}>
        <div className='signUpTop'>
          <div className='signUpTitle'>{title}</div>      
          <div className='signUpPrice'>{price}</div>
          <div className='signUpDesc'>
            {desc}
          </div>
          <div className='signUpDetails'>
            <ul>
            {detailsComp}
            </ul>
          </div>
        </div>
        <div className='signUpFooter'>
          {formComp}
          <div className='signUpButtonArea'>
            <FormButton style={{minWidth: 200}} isLocked={Boolean(!submitEnabled) || Boolean(passwdComp)} onClick={handleSignUp} key='submitSignUp'>{bCall}</FormButton> 
          </div>
        </div>
      </div>
      
      {passwdComp}

      {showError && <div className='errorResp'>
                      <div className='errLabel'>Error Message:</div> 
                      <div className='errVal'>{errorResp.title}</div>
                      <div className='errLabel'>Cause</div>
                      <div className='errVal'>{errorResp.cause}</div>
                      <div className='errLabel'>Suggestion</div>
                      <div className='errVal'>{errorResp.suggestion}</div>
                      <div className='errLabel'>Log Finder Id</div>
                      <div className='errVal'>{errorResp.logFinder}</div>
                      <CopyToClip text={errorResp.logFinder}/>
                    </div>
}
    </div>
  )
}


/*

{
  "actCodeExists": false,
  "actCodeNonExpired": false,
  "accountEnabled": false,
  "authenticityEstimationPassed": false,
  "logFinder": "36f2d146-4752-454d-9b79-e299f5f4a2fe",
  "title": "Sorry. Unexpected Server Error.",
  "note": "We apologize for the inconvenience. We're on it!",
  "blockers": [],
  "supportOptions": [
    "HelpDesk@kiponos.io",
    "Log Finder ID: 36f2d146-4752-454d-9b79-e299f5f4a2fe"
  ],
  "userActions": [
    "You may safely login with your username and password you've signed up with",
    "If you don't know or lost your credentials, you can contact support to recover your username or reset your password."
  ],
  "ourActions": [
    "Our support team has been notified."
  ],
  "progressOptions": []
}


*/
